<template>
  <div class="min-h-screen flex items-center justify-center px-4">
    <div class="max-w-md w-full space-y-8">
      <!-- Logo/Header -->
      <div class="text-center">
        <h1 class="text-4xl font-bold text-primary-600">🛒</h1>
        <h2 class="mt-4 text-3xl font-bold">{{ $t('auth.forgotPassword.title') }}</h2>
        <p class="mt-2 text-gray-600">
          {{ $t('auth.forgotPassword.description') }}
        </p>
      </div>

      <!-- Success Message -->
      <div v-if="successMessage" class="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg">
        {{ successMessage }}
      </div>

      <!-- Error Message -->
      <div v-if="errorMessage" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
        {{ errorMessage }}
      </div>

      <!-- Form (hide after successful submission) -->
      <form v-if="!successMessage" @submit.prevent="handleSubmit" class="mt-8 space-y-6">
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700 mb-1">
            {{ $t('common.email') }}
          </label>
          <input
            id="email"
            v-model="email"
            type="email"
            required
            class="input"
            placeholder="you@example.com"
            :disabled="loading"
          />
        </div>

        <button
          type="submit"
          class="w-full btn btn-primary"
          :disabled="loading"
        >
          {{ loading ? $t('auth.forgotPassword.sending') : $t('auth.forgotPassword.button') }}
        </button>
      </form>

      <!-- Back to Login -->
      <div class="text-center">
        <router-link
          to="/login"
          class="text-primary-600 hover:text-primary-500 font-medium"
        >
          {{ $t('auth.forgotPassword.backToSignIn') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuth } from '../composables/useAuth'

const { t } = useI18n()
const { requestPasswordReset } = useAuth()

const email = ref('')
const loading = ref(false)
const errorMessage = ref('')
const successMessage = ref('')

const handleSubmit = async () => {
  errorMessage.value = ''
  successMessage.value = ''
  loading.value = true

  try {
    const result = await requestPasswordReset(email.value)

    if (result.success) {
      successMessage.value = result.message || t('auth.forgotPassword.successMessage')
    } else {
      errorMessage.value = result.error
    }
  } finally {
    loading.value = false
  }
}
</script>
